import { render, staticRenderFns } from "./UpdateCaseCreationOrder.vue?vue&type=template&id=bf669182&scoped=true&"
import script from "./UpdateCaseCreationOrder.vue?vue&type=script&lang=js&"
export * from "./UpdateCaseCreationOrder.vue?vue&type=script&lang=js&"
import style0 from "./UpdateCaseCreationOrder.vue?vue&type=style&index=0&id=bf669182&scoped=true&lang=css&"
import style1 from "./UpdateCaseCreationOrder.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf669182",
  null
  
)

component.options.__file = "UpdateCaseCreationOrder.vue"
export default component.exports